import React, { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/HomePage';
import Login from './pages/LoginPage';

import { UserRoleProvider } from './context/UserRoleContext';
import { EventProvider } from './context/EventContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

import PrivateRoute from './Routes/PrivateRoute';

import './styles/App.css';
import { BillingComponent } from './components/BillingComponent';
import RolesDashboard from './components/RolesDashboard';
import HostForm from './components/HostForm';
import OrganizationDisplay from './components/OrganizationDisplay';
import HostDisplay from './components/HostDisplay';
import CreateHostOrgDescComponent from './components/CreateHostOrgDescComponent';
import { EditEventDetailsPage } from './components/EditEventDetailsComponent';
import ScorecardDashboard from './components/ScorecardDashboardComponent';
import GroupDashboard from './components/GroupDashboard';
import EditEventInstrument from './components/EditEventInstrumentComponent';
import { CreateRegistrantComponent } from './components/CreateRegistrantComponent';
import MessageComponent from './components/MessageComponent';
import RegistrantList from './components/RegistrantTable';
import CreateEventComponent from './components/CreateEventComponent';
import EventSelect from './components/EventSelect';
import EventOverview from './components/EventOverview';
import SideBar from './components/SideBarComponent';
import QRComponent from './components/QRComponent';
import { UserProfileComponent } from './components/UserProfileComponent';
import EventLogoComponent from './components/EventLogoComponent';
import CreateUserForm from './components/CreateUserComponent';
import VerifyAccount from './components/VerifyAccountComponent';
import RegistrationSuccessComponent from './components/RegistrationSuccessComponent';
import OrganizationSuccessComponent from './components/OrganizationSuccessComponent';
import HostSuccessComponent from './components/HostSuccessComponent';
import CheckInSuccessComponent from './components/CheckInSuccessComponent';
import CheckInComponent from './components/CheckInComponent';
import { EditEventQuestionComponent } from './components/EditEventQuestions';
import { EditRegistrantComponent } from './components/EditRegistrantComponent';
import RegistrantUpdateSuccessComponent from './components/RegistrantUpdateSuccessComponent';
import { ROUTES } from './constants/routes';
import WelcomePage from './pages/WelcomePage';
import UnsubscribePage from './components/UnsubscribeComponent';
import UnsubscribeComponent from './components/UnsubscribeComponent';
import ChooseHostComponnt from './components/ChooseHostComponent';

const App: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState('overview');

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const closeSideBar = () => {
    setIsSidebarOpen(false);
  }

  const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); // initial check
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <UserRoleProvider>
            <EventProvider>
              <BrowserRouter>
                <Navbar
                  setSidebarOpen={toggleSidebar}
                  setSelectedTab={setSelectedTab}
                  isSidebarOpen={isSidebarOpen}
                />
                <div style={{ marginTop: '50px' }}>
                  {isSidebarOpen && (
                    <SideBar closeSideBar={closeSideBar} />
                  )}
                  <div style={{ ...styles.contentContainer, marginLeft: !isMobile && isSidebarOpen ? '220px' : '0px' }}>

                    <Routes>
                      {/* Public Routes */}
                      <Route path={ROUTES.LOGIN} element={<Login />} />
                      <Route path={ROUTES.WELCOME} element={<WelcomePage />} />
                      <Route path={ROUTES.ROOT} element={<WelcomePage />} />
                      <Route path={ROUTES.CREATE_ACCOUNT} element={<CreateUserForm />} />
                      <Route path={ROUTES.VERIFY_ACCOUNT + "/:email"} element={<VerifyAccount />} />
                      <Route path={ROUTES.REGISTRATION_SUCCESS} element={<RegistrationSuccessComponent />} />


                      <Route
                        path={ROUTES.CYNE_UP} element={<CreateRegistrantComponent />} />

                      <Route
                        path={ROUTES.CYNE_UP + "/:event_code"}
                        element={<CreateRegistrantComponent />} />

                      <Route
                        path={ROUTES.UNSUBSCRIBE}
                        element={<UnsubscribeComponent />} />

                      <Route
                        path={ROUTES.CHECKIN + "/:event_code"}
                        element={<CheckInComponent />} />

                      <Route
                        path={ROUTES.CHECKIN}
                        element={<CheckInComponent />} />


                      <Route
                        path={ROUTES.CHECKIN_SUCCESS + "/:event_code"}
                        element={<CheckInSuccessComponent />} />

                      <Route path={ROUTES.HOME} element={
                        <PrivateRoute>
                          <Home />
                        </PrivateRoute>} />

                      {/* Protected Routes */}

                      <Route path={ROUTES.REGISTRANT_UPDATE_SUCCESS}
                       element={
                        <PrivateRoute>
                        <RegistrantUpdateSuccessComponent />
                        </PrivateRoute>

                       } />

                      <Route path={ROUTES.CHOOSE_HOST}
                       element={
                        <PrivateRoute>
                        <ChooseHostComponnt />
                        </PrivateRoute>

                       } />


                      <Route
                        path={ROUTES.EVENT_OVERVIEW}
                        element={
                          <PrivateRoute>
                            <EventOverview />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.SWITCH_EVENTS}
                        element={
                          <PrivateRoute>
                            <EventSelect />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.EDIT_EVENT_QUESTIONS}
                        element={
                          <PrivateRoute>
                            <EditEventQuestionComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.CREATE_EVENT}
                        element={
                          <PrivateRoute>
                            <CreateEventComponent />
                          </PrivateRoute>
                        }
                      />
                      {/* <Route
                        path={ROUTES.ORGANIZATION_SUCCESS}
                        element={
                          <PrivateRoute>
                            <OrganizationSuccessComponent />
                          </PrivateRoute>
                        }
                      /> */}
                      <Route
                        path={ROUTES.HOST_SUCCESS}
                        element={
                          <PrivateRoute>
                            <HostSuccessComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.REGISTRANTS_LIST}
                        element={
                          <PrivateRoute>
                            <RegistrantList />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.EDIT_REGISTRANT + "/:registrant_id"}
                        element={
                          <PrivateRoute>
                            <EditRegistrantComponent />
                          </PrivateRoute>
                        }
                      />
                      {/* <Route
                        path="/organization-registrants-list"
                        element={
                          <PrivateRoute>
                            <OrganizationRegistrantList />
                          </PrivateRoute>
                        }
                      /> */}
                      <Route
                        path={ROUTES.CREATE_OVERVIEW}
                        element={
                          <PrivateRoute>
                            <CreateHostOrgDescComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.MESSAGES}
                        element={
                          <PrivateRoute>
                            <MessageComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.QR_CODES}
                        element={
                          <PrivateRoute>
                            <QRComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.EDIT_EVENT_INSTRUMENTS}
                        element={
                          <PrivateRoute>
                            <EditEventInstrument />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.CREATE_REGISTRANT}
                        element={
                          <PrivateRoute>
                            <CreateRegistrantComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.PROFILE}
                        element={
                          <PrivateRoute>
                            <div>Profile Content</div>
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.GROUPS}
                        element={
                          <PrivateRoute>
                            <GroupDashboard />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.SCORECARDS}
                        element={
                          <PrivateRoute>
                            <ScorecardDashboard />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.EDIT_EVENT}
                        element={
                          <PrivateRoute>
                            <EditEventDetailsPage />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.EVENT_LOGO}
                        element={
                          <PrivateRoute>
                            <EventLogoComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.HOST_ORG_OVERVIEW}
                        element={
                          <PrivateRoute>
                            <CreateHostOrgDescComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.HOST_OVERVIEW}
                        element={
                          <PrivateRoute>
                            <HostDisplay />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.ORGANIZATION_OVERVIEW}
                        element={
                          <PrivateRoute>
                            <OrganizationDisplay />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.UPDATE_HOST}
                        element={
                          <PrivateRoute>
                            <HostForm />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.CREATE_HOST}
                        element={
                          <PrivateRoute>
                            <HostForm />
                          </PrivateRoute>
                        }
                      />
                      {/* <Route
                        path={ROUTES.UPDATE_ORGANIZATION}
                        element={
                          <PrivateRoute>
                            <OrganizationForm />
                          </PrivateRoute>
                        }
                      /> */}
                      {/* <Route
                        path={ROUTES.CREATE_ORGANIZATION}
                        element={
                          <PrivateRoute>
                            <OrganizationForm />
                          </PrivateRoute>
                        }
                      /> */}
                      <Route
                        path={ROUTES.USER_PROFILE}
                        element={
                          <PrivateRoute>
                            <UserProfileComponent />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.ROLES}
                        element={
                          <PrivateRoute>
                            <RolesDashboard />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path={ROUTES.BILLING}
                        element={
                          <PrivateRoute>
                            <BillingComponent />
                          </PrivateRoute>
                        }
                      />

                      {/* Default Route to redirect to home */}
                      <Route path="*" element={<Navigate to={ROUTES.HOME} />} />
                    </Routes>
                  </div>
                </div>
              </BrowserRouter>
            </EventProvider>
          </UserRoleProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
};

const styles = {
  dashboardContainer: {
    display: 'flex',
    //marginTop: '60px', // Add top margin to avoid overlap with fixed navbar (adjust based on your navbar height)
  },
  contentContainer: {
    transition: 'margin-left 0.3s ease',
    padding: '20px', // Add padding for content
    flex: 1, // Allow content to take up remaining space
  },
};

export default App;
